module.exports = __webpack_public_path__ + "img/austria-genitourinary-diseases-female.7ed8f6e2.png";